const state = {
    item: {},
    pageKey: 'emergency',
    pageName: 'Emergency',
    settings: {
        pageName: 'Emergency Settings',
        pageKey: 'emergency/settings',
        item: {}
    }
}

const mutations = {
    SET_ITEM: (state, item) => {
        state.item = item
    },
    PATCH_ITEM: (state, data) => {
        state.item = Object.assign({}, state.item, data)
    },
    REMOVE_ITEM: (state) => {
        state.item = {}
    },
    SET_SETTINGS_ITEM: (state, item) => {
        state.settings.item = item
    },
    PATCH_SETTINGS_ITEM: (state, data) => {
        state.settings.item = Object.assign({}, state.settings.item, data)
    },
    REMOVE_SETTINGS_ITEM: (state) => {
        state.settings.item = {}
    },
}

const actions = {
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}